import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import PortfolioPage from './pages/PortfolioPage';
import AboutPage from './pages/AboutPage';
import BlogPage from './pages/BlogPage'; // Import BlogPage
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Switch>
          <Route exact path="/" component={AboutPage} />
          <Route path="/portfolio" component={PortfolioPage} />
          <Route path="/about" component={AboutPage} />
          <Route path="/blog" component={BlogPage} /> {/* Uncommented blog route */}
        </Switch>
        <Footer />
      </div>
    </Router>
  );
}

export default App;